import { render, staticRenderFns } from "./quillEditor.vue?vue&type=template&id=710b8d84"
import script from "./quillEditor.vue?vue&type=script&lang=js"
export * from "./quillEditor.vue?vue&type=script&lang=js"
import style0 from "./quillEditor.vue?vue&type=style&index=0&id=710b8d84&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports